import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import { routePublic } from "../../routes/PublicRoutePath";
import { ICButton } from "../../core-component/ui";

const UnauthorizedAccess = () => {
  const navigate = useNavigate();
  const { t } = UseTranslationHook();
  const [countdown, setCountdown] = useState(5);
  useEffect(() => {
    localStorage.clear();
    const redirectToLogin = () => {
      navigate("/" + routePublic.login);
    };
    const timer = setTimeout(() => {
      redirectToLogin();
    }, 5000);
    const interval = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);
    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, [navigate]);

  return (
    <div className="flex justify-center items-center h-svh bg-base">
      <div className="text-center bg-subtle p-10 rounded-xl shadow-md">
        <h1 className="text-4xl">{t("unauthorized_access")}</h1>
        <p>{t("not_permission")}</p>
        <p>
          {t("redirect_message")} {countdown} {t("seconds")}
        </p>
        <ICButton
          onClick={() => {
            localStorage.clear();
            navigate("/" + routePublic.login);
          }}
        >
          {t("sign_out")}
        </ICButton>
      </div>
    </div>
  );
};

export default UnauthorizedAccess;
